import React, { Component } from "react";
import { Icon, Spin } from "antd";

class PreloadingMask extends Component {
  constructor(props) {
    super(props);
    this.state = {
      visible: null
    };
  }

  render() {
    return (
      <div
        id="preloadingAssetMask"
        data-visible={this.props.visible}
        className="preloading-mask"
      >
        <span className="d-none">
          <Icon type="loading" />
        </span>
        {this.props.fetched && false ? (
          <Icon
            type="check-circle"
            style={{ fontSize: "24px", color: "#2ecc71" }}
          />
        ) : (
          <Spin />
        )}
        <span style={{ display: "none" }} id="svgLoader">
          <div className="loader">
            <div />
            <div />
            <div />
            <div />
            <div />
            <div />
            <div />
            <div />
            <div />
          </div>
        </span>
        <span data-translationkey="loading" className="d-none loading-text">
          ADPOINT
        </span>
        {this.props.text && <span>{this.props.text}</span>}
      </div>
    );
  }
}

export default PreloadingMask;



// WEBPACK FOOTER //
// ./src/components/PreloadingMask.js